import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxtostring">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtostring')}
            </Typography>
            <p><strong>{translate('fxtostring')}</strong> chuyển kiểu dữ liệu của giá trị bất kỳ thành trả về một chuỗi.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là giá trị bất kì.</td>
                                <td>123</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToString(123) trả về "123"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxleft">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxleft')}
            </Typography>
            <p><strong>{translate('fxleft')}</strong> trả về số lượng ký tự được chỉ định bởi <strong>{translate('numberofcharacters')}</strong>, tính từ bên trái.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('numberofcharacters')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là 1 số bất kì.</td>
                                <td>4</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Left("abcdefghij", 4) trả về "abcd"</div>
                    <div>2. Left("abcdefghij", 2) trả về "ab"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmiddle">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmiddle')}
            </Typography>
            <p><strong>{translate('fxmiddle')}</strong> trả về số lượng ký tự được chỉ định bởi <strong>{translate('numberofcharacters')}</strong>, tính từ bên vị trí chỉ định bởi <strong>{translate('start')}</strong>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('start')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là 1 số bất kì.</td>
                                <td>5</td>
                            </tr>
                            <tr>
                                <td>{translate('numberofcharacters')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là 1 số bất kì.</td>
                                <td>7</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Middle("abcdefghij", 5, 7) trả về "fg"</div>
                    <div>2. Middle("abcdefghij", 2, 4) trả về "cd"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxright">
                4.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxright')}
            </Typography>
            <p><strong>{translate('fxright')}</strong> trả về số lượng ký tự được chỉ định bởi <strong>{translate('numberofcharacters')}</strong>, tính từ bên phải.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('numberofcharacters')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là 1 số bất kì.</td>
                                <td>4</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Right("abcdefghij", 2) trả về "ij"</div>
                    <div>2. Right("abcdefghij", 5) trả về "fghij"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxstringlength">
                5.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxstringlength')}
            </Typography>
            <p><strong>{translate('fxstringlength')}</strong> trả về số ký tự của chuỗi.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. StringLength("abcdefghij") trả về 10</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtolower">
                6.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtolower')}
            </Typography>
            <p><strong>{translate('fxtolower')}</strong> trả về tất cả các chữ cái trong văn bản được chỉ định dưới dạng chữ thường.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"ABCD"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToLower("ABCD", 2) trả về "abcd"</div>
                    <div>2. ToLower("ABCDefghij", 5) trả về "abcdefghij"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtoupper">
                7.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtoupper')}
            </Typography>
            <p><strong>{translate('fxtoupper')}</strong> trả về tất cả các chữ cái trong văn bản được chỉ định dưới dạng chữ hoa.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"abcd"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToUpper("abcd", 2) trả về "ABCD"</div>
                    <div>2. ToUpper("abcdefghij", 5) trả về "ABCDEFGHIJ"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxpatterncount">
                8.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxpatterncount')}
            </Typography>
            <p><strong>{translate('fxpatterncount')}</strong> trả về số lần xuất hiện của chuỗi tìm kiếm trong văn bản.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"Mississippi"</td>
                            </tr>
                            <tr>
                                <td>{translate('searchstring')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là chuỗi cần tìm kiếm.</td>
                                <td>"is"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. PatternCount("Mississippi", "is") trả về 2</div>
                    <div>2. PatternCount("Mississippi", "s") trả về 4</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxsubstitute">
                9.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxsubstitute')}
            </Typography>
            <p><strong>{translate('fxsubstitute')}</strong> trả về một chuỗi văn bản với mọi lần xuất hiện của chuỗi tìm kiếm trong văn bản đã chỉ định được thay thế bằng chuỗi thay thế.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('searchstring')},{translate('replacestring')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Là chuỗi cần tìm kiếm và chuỗi cần thay thế.</td>
                                <td>[["a", "A"]]</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Substitute("abcdefghij", [[ "a" , "A" ]]) trả về "Abcdefghij"</div>
                    <div>2. Substitute("abcdefghij", [[ "ab" , "12" ]]) trả về "12cdefghij"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtotrim">
                10.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtotrim')}
            </Typography>
            <p><strong>{translate('fxtotrim')}</strong> trả về văn bản đã loại bỏ tất cả các khoảng trắng ở đầu và cuối.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>" abcd "</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToTrim(" abcd ") trả về "abcd"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtotrimall">
                11.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtotrimall')}
            </Typography>
            <p><strong>{translate('fxtotrimall')}</strong> trả về văn bản đã loại bỏ tất cả các khoảng trắng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>" Julian       Scott Dunn "</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToTrimAll(" Julian       Scott Dunn ") trả về "JulianScottDunn"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxindexofstring">
                12.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxindexofstring')}
            </Typography>
            <p><strong>{translate('fxindexofstring')}</strong> trả về chỉ mục của phần tử đầu tiên trong văn bản.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"hello world"</td>
                            </tr>
                            <tr>
                                <td>{translate('searchstring')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là chuỗi cần tìm kiếm.</td>
                                <td>"lo"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. IndexOfString("hello world", "lo") trả về 3</div>
                    <div>2. IndexOfString("hello world", " w") trả về 5</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxsplit">
                13.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxsplit')}
            </Typography>
            <p><strong>{translate('fxsplit')}</strong> trả về mảng các chuỗi, được phân tách tại mỗi điểm tại đó dấu phân cách xuất hiện trong chuỗi đã cho.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"hello world"</td>
                            </tr>
                            <tr>
                                <td>{translate('splitwith')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là chuỗi dùng để phân tách.</td>
                                <td>" "</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. IndexOfString("hello world", " ") trả về ["hello", "world"]</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmatch">
                14.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmatch')}
            </Typography>
            <p><strong>{translate('fxmatch')}</strong> trả về mảng các chuỗi, có kết quả khớp một chuỗi với 1 chuỗi thông thường hoặc 1 biểu thức chính quy.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi bất kì.</td>
                                <td>"hello world"</td>
                            </tr>
                            <tr>
                                <td>{translate('regexp')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là 1 chuỗi thông thường hoặc 1 biểu thức chính quy.</td>
                                <td>"[A-Z]"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Match("hello world", "[A-Z]") trả về ["h", "e", "l", "l", "o", "w", "o", "r", "l", "d"]</div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);